/**
 * Reveal phone-card CTA after the phone graphic has loaded (or on error / timeout).
 */
function initPhoneCards() {
	const cards = document.querySelectorAll( '.wp-block-embark-phone-card--defer-button' );
	if ( ! cards.length ) {
		return;
	}

	cards.forEach( ( card ) => {
		const reveal = () => {
			card.classList.add( 'is-phone-ready' );
		};

		const phone = card.querySelector( '.wp-block-embark-phone-card__phone' );
		const img = phone ? phone.querySelector( 'img' ) : null;

		if ( ! img ) {
			reveal();
			return;
		}

		if ( img.complete && img.naturalHeight > 0 ) {
			requestAnimationFrame( reveal );
			return;
		}

		const maxWait = window.setTimeout( reveal, 10000 );

		const done = () => {
			window.clearTimeout( maxWait );
			reveal();
		};

		img.addEventListener( 'load', done, { once: true } );
		img.addEventListener( 'error', done, { once: true } );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initPhoneCards );
} else {
	initPhoneCards();
}
